import AdminLayout from "../../layouts/AdminLayout";
import ProjectJobFilter from "../../components/pages/admin/modals/ProjectFilter/ProjectJobFilter";
import { curSym } from "../../utils/pip";
import { useEffect, useState } from "react";
import Loader from "../../components/loader";
import { useLocation } from "react-router-dom";
import NoRecord from "../../components/form/NoRecord";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAdminProject,
  fetchProjectFreelancer,
  inviteToProject,
} from "../../redux/features/admin/actions/projectAction";
import PaginationDropdown from "../../components/table/PaginationDropdown";
import ReactPagination from "../../components/table/ReactPagination";
import InviteFreelancer from "../../components/Modals/common/project/InviteFreelancer";
import { setIsInvite } from "../../redux/features/admin/reducers/projectReducer";

const InviteProject = () => {
  const dispatch = useDispatch();
  const project_id = useLocation()?.state?.id || "";
  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);
  const [searchFilter, setSearchFilter] = useState()


  const { isLoading, matchFreelancerList, isInvite, projectList } = useSelector(
    (state) => state?.admin?.project
  );
  useEffect(() => {
    dispatch(fetchProjectFreelancer({ payload: project_id }));
    dispatch(fetchAdminProject());
  }, []);

  const paginatedList = matchFreelancerList?.filter((item) => {
    const fullname = `${item?.first_name} ${item?.last_name}`
    const matchSearchName =
      !searchFilter ||
      fullname?.toLowerCase().includes(searchFilter.toLowerCase());
    return matchSearchName;
  })?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleInvite = (freelancer_id) => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchProjectFreelancer({ payload: project_id }));
        dispatch(setIsInvite(false));
      }
    };
    dispatch(
      inviteToProject({
        payload: { project_id, freelancer_id },
        callback,
      })
    );
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <AdminLayout />
      <div className="ct_px_40 mt-4">
        <div className="row">
          <ProjectJobFilter />
          <div className="col-lg-9 col-md-9 mb-4 mb-md-0">
            <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199">
              <div>
                <h4 className="mb-0 ct_fs_20  mb-0">Select a Freelancer </h4>
                <p className="mb-0 ct_text_clr_757886">
                  Browse and invite a qualified freelancer to collaborate on
                  your project
                </p>
              </div>
              <div className="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_575">
                <div className="position-relative ct_w_100_575">
                  <input
                    type="text"
                    className="form-control ct_input  ps-5"
                    placeholder="Search by Name"
                    value={searchFilter}
                    onChange={(e) => {
                      setSearchFilter(e?.target?.value);
                    }}
                  />
                  <i className="fa-solid fa-search ct_input_icon_left"></i>
                </div>
              </div>
            </div>

            <div className="row mt-5">
              {paginatedList?.length > 0 && (
                <>
                  {paginatedList?.map((item, index) => (
                    <div className="col-xxl-3 col-xl-6 col-lg-6 mb-4">
                      <div class="ct_outline_bg ct_p_10 d-grid h-100">
                        <div>
                          <div class="d-flex align-items-start gap-3 justify-content-between">
                            <img
                              src="../assets/img/Avatar_11_big.png"
                              className="ct_img_72"
                            />
                            <span
                              class="ct_badge ct_fs_12 ct_orange_text"
                              style={{
                                borderColor: " var(--yellow)",
                                backgroundColor: "hsl(43deg 100% 51% / 10%)",
                              }}
                            >
                              NuGlow{" "}
                              <img
                                src="../assets/img/noto_fire.png"
                                width="10px"
                                height="10px"
                              />
                            </span>
                          </div>
                          <div class="ct_mt_20">
                            <h5 class="ct_fs_16 mb-2 ct_darkblue_text">
                              {`${item?.first_name} ${item?.last_name}`}{" "}
                            </h5>
                            <div class="d-flex align-items-center gap-3 gap-md-5">
                              <p class="ct_grey_text  ct_fs_12 mb-0">
                                {item?.talent_role || "#N/A"}{" "}
                              </p>
                              <p class="ct_grey_text ct_fs_12 mb-0">
                                {curSym}
                                {item?.salary_preference || 0} Per Project
                              </p>
                            </div>
                            <div class="d-flex align-items-center gap-3 justify-content-between ct_mt_10">
                              <p class="ct_grey_text  ct_fs_12 mb-0">
                                <i class="fa-solid fa-star ct_yellow_text ct_fs_12 me-2"></i>
                                4.3 (15 Reviews){" "}
                              </p>
                              <p class="ct_grey_text ct_fs_12 mb-0">
                                <span
                                  className="ct_dot_10 me-1"
                                  style={{ backgroundColor: "var(--yellow)" }}
                                ></span>
                                {item?.search_status || "#N/A"}
                              </p>
                            </div>
                            <div className="ct_mt_10">
                              <p className="ct_grey_text ct_fs_12 ct_para_scroll ct_custom_scroll">
                                Landing Pages for Tech Summit
                              </p>
                            </div>

                            <ul className="d-flex align-items-center gap-3 flex-wrap ct_custom_scroll ct_para_scroll">
                              {item?.skills?.split(",")?.map((obj) => (
                                <li>
                                  <span
                                    className="ct_badge ct_fs_12 px-3"
                                    style={{
                                      backgroundColor:
                                        "hsl(200deg 94% 14% / 6%)",
                                      borderColor: "transparent",
                                    }}
                                  >
                                    {obj}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        <div className="mt-auto">
                          <div class="ct_mt_30 text-center">
                            <button
                              class="ct_yellow_btn ct_outline_darksky ct_h_44 px-4 mx-auto"
                              style={{ color: "#219EBC" }}
                              // data-bs-target="#ct_job_details_modal"
                              // data-bs-toggle="modal"
                              disabled={item?.is_invited}
                              onClick={() => {
                                handleInvite(item?.user_id);
                              }}
                            >
                              {item?.is_invited ? (
                                "Invited"
                              ) : (
                                <>
                                  Invite to Project{" "}
                                  <i class="fa-solid fa-arrow-right ms-1"></i>
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
              {paginatedList?.length == 0 && <NoRecord />}

              {paginatedList?.length > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-4 ">
                  <div>
                    <PaginationDropdown
                      onChange={(val) => {
                        setListPerPages(val);
                        setCurrentPage(0);
                      }}
                    />
                  </div>
                  <div>
                    <ReactPagination
                      pageCount={Math.ceil(
                        matchFreelancerList?.length / listPerPages
                      )}
                      onPageChange={handlePageClick}
                      currentPage={currentPage}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteProject;
